<script lang="ts">
  import { getContext } from 'svelte'
  import type { HTMLAttributes } from 'svelte/elements'

  type Props = HTMLAttributes<HTMLDivElement>

  let { children, ...rest }: Props = $props()

  const { open, disabled } = getContext('pane') as PaneContext
</script>

{#if $open && !$disabled}
  <div {...rest}>
    {@render children?.()}
  </div>
{/if}
